<textarea
  [disabled]="disabled"
  [placeholder]="placeholder"
  (change)="onChange($event)"
  (input)="onInput($event)"
></textarea>
